export default __webpack_public_path__ + "static/media/Minicard_4h.eea3e4dd.svg";